export const moduleActions = {
  TABLEROS_EXPO: "TABLEROS_EXPO",
  TABLEROS_ADUANA: "TABLEROS_ADUANA",
  ADMIN_USERS: "ADMIN_USERS",
  ADMIN_ALERTS: "ADMIN_ALERTS",
  ADMIN_STADISTICS: "ADMIN_STADISTICS",
  ADMIN_GROUPS: "ADMIN_GROUPS",
};
// Roles
// 1	"Administrador"
// 2	"Cliente"
// 3	"Roldan"
// 4	"Roldan SU"
// 5	"Gestor Documental"
export const roleModuleFilter = [
  {
    Rol: 1,
    Full: true,
    Actions: [],
  },
  {
    Rol: 2,
    Filters: [],
  },
  {
    Rol: 3,
    Filters: [moduleActions.TABLEROS_ADUANA],
  },
  {
    Rol: 4,
    Filters: [
      moduleActions.TABLEROS_ADUANA,
      moduleActions.ADMIN_STADISTICS,
      moduleActions.ADMIN_GROUPS,
    ],
  },
  {
    Rol: 5,
    Filters: [],
  },
];

export const roleModuleAction = [
  {
    Rol: 1,
    Full: true,
    Actions: [moduleActions.TABLEROS_EXPO],
  },
  {
    Rol: 2,
    Actions: [],
  },
  {
    Rol: 3,
    Full: true,
    Actions: [moduleActions.TABLEROS_EXPO],
  },
  {
    Rol: 4,
    Full: true,
    Actions: [moduleActions.TABLEROS_EXPO],
  },
  {
    Rol: 5,
    Full: true,
    Actions: [moduleActions.TABLEROS_EXPO],
  },
];
